import React from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {Row} from 'react-bootstrap';

import {getLanguage, t} from 'react-switch-lang';

import InputText from '../../../../components/FormFields/InputText';
import InputDate from '../../../../components/FormFields/inputDate/InputDate';

import SelectInfinite from '../../../../components/FormFields/SelectInfinite';
import SelectList from '../../../../components/select/SelectList';

import './RevisionFilter.scss';
import {QUARTER, REVISION_MODE} from '../../const';
import {Col} from 'reactstrap';

const RevisionFilter = ({submit}) => {
  const lang = getLanguage();
  const methods = useForm({});
  const {handleSubmit, watch} = methods;
  const validFrom = watch('issuedAtFrom');
  const validTo = watch('issuedAtTo');

  return (
    <>
      <FormProvider {...methods}>
        <form
          className={'revisionFilterFormContainer'}
          onSubmit={handleSubmit(submit)}
        >
          <Row className="main-container pt-5 m-0 pb-5">
            <Col>
              <div style={{display: 'flex', gap: '20px', flexWrap: 'wrap'}}>
                <div style={{minWidth: '200px', maxWidth: '200px'}}>
                  <InputText
                    type="text"
                    name="searchInput"
                    placeholder={t('revisions.placeholder.referenceId')}
                  />
                </div>

                <div style={{maxWidth: '200px', minWidth: '200px'}}>
                  <InputDate
                    name="issuedAtFrom"
                    maxDate={validTo}
                    isClearable
                    placeholderText={t('risk-cosideration.search.dateFrom')}
                  />
                </div>
                <div style={{maxWidth: '200px', minWidth: '200px'}}>
                  <InputDate
                    name="issuedAtTo"
                    minDate={validFrom}
                    isClearable
                    placeholderText={t('risk-cosideration.search.dateTo')}
                  />
                </div>
                <SelectList
                  name="quarter"
                  className="select revisionFilterSelectList"
                  placeholder={t('revisions.placeholder.quarter')}
                  options={[
                    {label: QUARTER.I, value: QUARTER.I},
                    {label: QUARTER.II, value: QUARTER.II},
                    {label: QUARTER.III, value: QUARTER.III},
                    {label: QUARTER.IV, value: QUARTER.IV},
                  ]}
                  isClearable
                  isMulti
                />

                <SelectList
                  name="revisionMode"
                  className="select revisionFilterSelectList"
                  placeholder={t('revisions.placeholder.mode')}
                  options={[
                    {
                      label:
                        lang === 'mne'
                          ? REVISION_MODE.REGULAR_MNE
                          : REVISION_MODE.REGULAR,
                      value: REVISION_MODE.REGULAR,
                    },
                    {
                      label:
                        lang === 'mne'
                          ? REVISION_MODE.EXTRAORDINARY_MNE
                          : REVISION_MODE.EXTRAORDINARY,
                      value: REVISION_MODE.EXTRAORDINARY,
                    },
                  ]}
                  isClearable
                />
                <SelectInfinite
                  api="revision-scopes"
                  className="select"
                  name="revisionScopes"
                  placeholder={t('revisions.placeholder.area')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  pagination={false}
                  noSort={true}
                  isMulti
                />
                <SelectInfinite
                  className="select"
                  pagination={false}
                  noSort={true}
                  api="revision-types"
                  name="revisionType"
                  id="revisionType"
                  placeholder={t('revisions.placeholder.revisionType')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  isMulti
                />
              </div>
            </Col>

            <div
              style={{maxWidth: '200px', minWidth: '200px'}}
              className="wrapper__right"
            >
              <button
                className="float-right search-button primary-btn"
                disabled={false}
                type="submit"
              >
                {t('risk-cosideration.search.searchButton')}
              </button>
            </div>
          </Row>
        </form>
      </FormProvider>
    </>
  );
};
export default RevisionFilter;
